import { useState } from "react";

import CreditCardIcon from "@mui/icons-material/CreditCard";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import { Button, DialogActions, DialogContent, Paper, Typography } from "@mui/material";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import Tooltip from "@mui/material/Tooltip";

import usePlatform from "@/hooks/usePlatform";
import useThemeData from "@/hooks/useThemeData";


const IntroFlights = () => {
  const theme = useThemeData();
  const { isPc } = usePlatform();
  const [visible, setVisible] = useState(false);
  const bgBlack = "https://img.awardtool.com/guides/website-img/flights-deals-bg-black.jpg";
  const bgWhite = "https://img.awardtool.com/guides/website-img/flights-deals-bg-white.jpg";

  return (
    <Paper
      elevation={1}
      className="!rounded-[4px]"
      style={{
        backgroundColor: theme.isDarkMode ? "#202124" : "#f1f3fb",
      }}
    >
      <div className="flex items-center justify-between h-[70px]">
        <div className="pl-[20px] flex items-center">
          <div className="w-[30px] h-[30px] mr-[10px]">
            <CreditCardIcon color="primary" />
          </div>
          <div>
            <div className="flex items-center">
              <Typography
                sx={{
                  fontWeight: "bold",
                }}
                variant="body1"
              >
                First-class Flights
              </Typography>
              {/* <Chip
                size="small"
                className="ml-[6px]"
                color="primary"
                label="NEW"
                sx={{
                  fontWeight: "bold",
                }}
              /> */}
            </div>
            <Typography className="flex items-center">
              {isPc
                ? "Make your journey unforgettable with an exclusive first-class flight experience."
                : "Make your journey unforgettable."}{" "}
              <Tooltip
                sx={{ size: 10 }}
                title="We're aggregating special flights operated by renowed airlines including ANA, Lufthansa, Qatar Airways, Singapore Airlines and Cathay Pacific. Prices include required points + taxes for 1 adult. Optional charges and bag fees may apply. We show real-time results, and airline inventory and prices can change quickly."
              >
                <InfoOutlinedIcon
                  onClick={() => {
                    if (!isPc) {
                      setVisible(true);
                    }
                  }}
                  sx={{ fontSize: 16, margin: "auto" }}
                />
              </Tooltip>
            </Typography>
          </div>
        </div>

        {isPc && <img className="h-[100%] mr-[40px]" src={theme.isDarkMode ? bgBlack : bgWhite} alt="" />}

        <Dialog
          open={visible}
          onClose={() => setVisible(false)}
          PaperProps={{
            sx: {
              borderRadius: "12px",
            },
          }}
        >
          <DialogContent>
            <Typography fontSize={16}>
              We're aggregating special flights operated by renowed airlines including ANA, Lufthansa, Qatar Airways, Singapore Airlines and Cathay Pacific. Prices include required points + taxes for 1 adult. Optional charges and bag fees may apply. We show real-time results, and airline inventory and prices can change quickly.
            </Typography>
          </DialogContent>
          <DialogActions>
            <Button onClick={() => setVisible(false)}>OK</Button>
          </DialogActions>
        </Dialog>
      </div>
    </Paper>
  );
};

export default IntroFlights;
